import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../../base';

export class Claims extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/claims`);
  }

  query(params?: any) {
    return this.api.query(params).pipe(
      tap((json) => json.claims.forEach((record: any) => this.processRecord(record)))
    );
  }

  getTotal() {
    return this.api.get('total').pipe(
      tap((json) => this.processRecord(json))
    );
  }

  private processRecord(record: any) {
    record.type = record.funds < 0 ? 'deposit' : 'withdraw';
    record.funds = new BigNumber(-record.funds || 0).fromDecimal();
    record.amount = record.funds;
    record.shares = new BigNumber(record.shares || 0).fromDecimal();
    record.price = record.shares.eq(0) ? null : record.funds.div(record.shares);
    record.fee = new BigNumber(0);
    record.gasFee = new BigNumber(0);
  }
}
